import React, { useState, useEffect, useRef } from 'react';
import PostCard from './PostCard';
import './LazyPostCard.css';

/**
 * 성능 최적화: Lazy Loading PostCard
 * 화면에 보일 때만 실제 PostCard를 렌더링
 */
const LazyPostCard = ({ post, onClick, onEdit, onDelete }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasBeenVisible, setHasBeenVisible] = useState(false);
  const cardRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
            setHasBeenVisible(true);
          } else {
            setIsVisible(false);
          }
        });
      },
      {
        rootMargin: '300px', // 화면 밖 300px 전에 미리 로드
        threshold: 0.01,
      }
    );

    if (cardRef.current) {
      observer.observe(cardRef.current);
    }

    return () => {
      if (cardRef.current) {
        observer.unobserve(cardRef.current);
      }
    };
  }, []);

  return (
    <div ref={cardRef} className="lazy-post-card-wrapper">
      {hasBeenVisible ? (
        <PostCard 
          post={post} 
          onClick={onClick} 
          onEdit={onEdit}
          onDelete={onDelete}
          isLazy={!isVisible}
        />
      ) : (
        // 플레이스홀더: 최소 높이만 유지
        <div className="lazy-post-card-placeholder">
          <div className="placeholder-shimmer" />
        </div>
      )}
    </div>
  );
};

export default LazyPostCard;

